import React from 'react';
import Skeleton from '../../common/skeleton';

const MemberAndDependentSkeleton = () => (
  <div className="setup-form col">
    <div id="formGridallowMember" className="form-group d-flex">
      <div className="form-check ">
        <Skeleton
          count={1}
          width={20}
          height={20}
          containerClassName={'form-label'}
        />
      </div>
      <div className="d-flex flex-column ml-3">
        <Skeleton
          count={1}
          width={185}
          height={18}
          containerClassName={'form-label mb-2'}
        />
        <Skeleton
          count={1}
          width={385}
          height={18}
          containerClassName={'form-label'}
        />
      </div>
    </div>
    <div id="formGridallowDependent" className="form-group d-flex">
      <div className="form-check ">
        <Skeleton
          count={1}
          width={20}
          height={20}
          containerClassName={'form-label'}
        />
      </div>
      <div className="d-flex flex-column ml-3">
        <Skeleton
          count={1}
          width={185}
          height={18}
          containerClassName={'form-label mb-2'}
        />
        <Skeleton
          count={1}
          width={385}
          height={18}
          containerClassName={'form-label'}
        />
      </div>
    </div>
    <div className="form-group d-flex flex-column">
      <Skeleton
        count={1}
        width={185}
        height={18}
        containerClassName={'form-label mb-1'}
      />
      <Skeleton count={1} height={38} containerClassName={'form-label'} />
    </div>
  </div>
);

export default MemberAndDependentSkeleton;
